export function isElementInside(childEl: Element | null, containerEl: Element) {
  let el: Element | null = childEl;
  while (el) {
    if (el === containerEl) {
      return true;
    }
    el = el.parentElement;
  }
  return false;
}
